const translations = {
    'attr.canopyCap': 'pokrycie koron',
    'attr.corruption': 'korupcja',
    'attr.fertility': 'żyzność',
    'attr.fishCap': 'limit ryb',
    'attr.wildlifeCap': 'limit zwierzyny',
};

export default translations;
